import { DatasetsInfoWithProgress } from '@mygpt/app/datasets/services';
import { Http, PageQuery } from '@mygpt/app/http';

/**
 * 获取全部数据集列表
 * @param params
 * @returns
 */
export const getDatasetsList = (params: PageQuery) => {
  const { get } = Http.use();
  return get(`/datasets`, { params });
};

export interface QueryBotDatasetsListParams extends PageQuery {
  aiId: string;
}

export interface QueryBotDatasetsListResponse {
  items: DatasetsInfoWithProgress[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

/**
 * 获取单个机器人的数据集列表
 * @param params
 * @returns
 */
export const queryBotDatasetsList = (params: QueryBotDatasetsListParams) => {
  const { aiId, ...rest } = params;
  const { get } = Http.use();
  return get<QueryBotDatasetsListResponse>(`/robots/${params.aiId}/datasets`, { params: rest });
};

export interface DataSourceStatistical {
  crawled: number;
  process: number;
  complete: number;
  fail: number;
  exceeded: number;
  deleted: number;
  ready: number;
  invalid: number;
  total: number;
}

export interface DataSourceStatisticalMap {
  file: DataSourceStatistical;
  website: DataSourceStatistical;
  sitemap: DataSourceStatistical;
  gitbook: DataSourceStatistical;
  faq: DataSourceStatistical;
  api: DataSourceStatistical;
  integration: DataSourceStatistical;
  total: DataSourceStatistical;
}

export interface DatasetState {
  dataset_id: string;
  dataset_name: string;
  datasource_statistical_map: DataSourceStatisticalMap;
}

export interface DatasetTrainingProgressResponse {
  dataset_state: Record<string, DatasetState>;
}

/**
 * 获取机器人数据集学习进度
 * @param params
 * @returns
 */
export const getDatasetTrainingProgress = (params: QueryBotDatasetsListParams) => {
  const { aiId, ...rest } = params;
  const { get } = Http.use();
  return get<DatasetTrainingProgressResponse>(`/datasets/training/progress/${params.aiId}`, { params: rest });
};

export interface IntegrationTypeCount {
  crawled: number;
  process: number;
  complete: number;
  fail: number;
  exceeded: number;
  deleted: number;
  ready: number;
  invalid: number;
}

export interface IntegrationState {
  integration_id: string;
  integration_name: string;
  type_count: IntegrationTypeCount;
}

export interface IntegrationTrainingProgressResponse {
  integration_state: Record<string, IntegrationState>;
}

/**
 * 获取数据集集成学习进度
 * @param datasetId 数据集ID
 * @returns
 */
export const getIntegrationTrainingProgress = (datasetId: string) => {
  const { get } = Http.use();
  return get<IntegrationTrainingProgressResponse>(`/datasets/training/progress/integration/${datasetId}`);
};

export interface BindBotDatasetsParams {
  aiId: string;
  datasetIds: Array<string>;
  type: 'bind' | 'unbind';
}

/**
 * 获取机器人 绑定/解绑 数据集
 * @param params
 * @returns
 */
export const bindBotDatasets = (params: BindBotDatasetsParams) => {
  const { aiId, datasetIds, type } = params;
  const { delete: deleteFn, post } = Http.use();

  if (type === 'bind') {
    return post(`/robots/${aiId}/datasets`, { dataset_ids: datasetIds });
  } else {
    return deleteFn(`/robots/${aiId}/datasets/${datasetIds[0]}`);
  }
};
